export const DEFAULT_TAGS = (countryCode) => {
  return [
    {
      path: `/${countryCode}/running-events`,
      title: `Running`,
    },
    {
      path: `/${countryCode}/triathlon-events`,
      title: `Triathlons`,
    },
    {
      path: `/${countryCode}/obstacle-course-events`,
      title: `Obstacle Races`,
    },
    {
      path: `/${countryCode}/road-cycling-events`,
      title: `Road Cycling`,
    },
    {
      path: `/${countryCode}/swimming-events`,
      title: `Swimming`,
    },
  ];
};
